import React from "react";

const REASONS = [
  { title: "Un seul interlocuteur", desc: "Du premier RDV à la réalisation de votre projet, je gère tout. Vous gagnez du temps et de la sérénité.", n: "01" },
  { n: "02", title: "Comparaison du marché", desc: "Plus de 30 partenaires bancaires et assureurs analysés pour chaque dossier." },
  { n: "03", title: "Sans honoraires en placement", desc: "En placement, aucun honoraire ne vous est facturé : je suis rémunéré par des commissions versées par les partenaires, en toute transparence." },
  { n: "04", title: "Suivi long terme", desc: "Je reste à vos côtés bien après la signature. Votre situation évolue, vos contrats aussi." },
];

export default function WhyMe() {
  return (
    <section data-testid="whyme-section" className="py-24 md:py-32 bg-md-primary text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-grain opacity-10 pointer-events-none" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-md-secondary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.25em] text-md-secondary font-bold mb-4">Pourquoi me choisir</div>
          <h2 className="font-serif text-4xl md:text-5xl font-medium leading-tight">
            Le courtage tel qu'il devrait <span className="italic">toujours</span> être.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {REASONS.map((r) => (
            <div
              key={r.n}
              data-testid={`whyme-card-${r.n}`}
              className="border-t border-white/15 pt-6 hover:border-md-secondary transition-colors duration-500"
            >
              <div className="font-serif text-5xl text-md-secondary mb-3">{r.n}</div>
              <h3 className="text-xl font-semibold mb-3">{r.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
